module.exports = "<p>\n  plainsight works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/plainsight/plainsight.component.html
// module id = ./src/app/plainsight/plainsight.component.html
// module chunks = main